import { WarningOutlined } from '@ant-design/icons';
import { Space, Tooltip, TooltipProps } from 'antd';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';

interface Props {
    firstItem: boolean;
    tooltipProps: TooltipProps;
    verified: boolean;
}

const styles = {
    icon: { marginTop: 10, paddingRight: 6 },
    iconFirst: { marginTop: 32, paddingRight: 6 }
};

const getIcon = (firstItem: boolean) => <WarningOutlined style={firstItem ? styles.iconFirst : styles.icon} />;

const UserInfoVerificationContainer = ({ children, verified, tooltipProps, firstItem }: PropsWithChildren<Props>) => {
    return (
        <Space align="start" className={clsx('full-width', 'child-full-width')} size={6}>
            {children}
            {!verified ? (
                tooltipProps ? (
                    <Tooltip {...tooltipProps}>{getIcon(firstItem)}</Tooltip>
                ) : (
                    getIcon(firstItem)
                )
            ) : null}
        </Space>
    );
};

export default UserInfoVerificationContainer;
